import React from 'react';
import API from '../../services/API';
import CustomStore from 'devextreme/data/custom_store';
import useStyles from '../styles/styles';
import { Column, DataGrid, Paging } from 'devextreme-react/data-grid';
import usePermissions from '../../hooks/usePermissions';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../global';
import { Template } from 'devextreme-react/core/template';

const devices = new CustomStore({
  key: 'DeviceId',
  load: async () => {
    const data = (await API.sendRequest(`Device`, 'get')).data;
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`Device`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`Device`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`Device/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const Device = () => {
  const classes = useStyles();

  /*********************************
   * Access Control
   *********************************/
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <LoadPermissions>Loading permissions</LoadPermissions>;
  }
  if (!ACL.Admin) {
    return (
      <LoadPermissions>
        You don't have access to this page. For Administrators Only.
      </LoadPermissions>
    );
  }
  /*********************************/

  return (
    <div className={classes.divGridContainer}>
      <DataGrid
        id={'gridContainer'}
        dataSource={devices}
        // keyExpr={'DeviceId'}
        allowColumnReordering={true}
        focusedRowEnabled
        showBorders={true}
        onRowUpdating={onRowUpdating}
        rowAlternationEnabled={true}
        showRowLines={true}
        headerFilter={{ visible: true }}
        filterPanel={{ visible: true }}
        filterRow={{ visible: true }}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />

        <Column dataField={'Model'} caption={'Device'} width={155} />
        <Column dataField={'Manufacturer'} width={125} />
        <Column dataField={'PhoneNumber'} width={130} />
        <Column dataField={'SerialNumber'} width={125} />
        <Column dataField={'OSVersion'} caption={'OS V.'} width={70} />
        <Column dataField={'AppVersion'} caption={'App V.'} width={75} />
        <Column dataField={'LinkedUser'} allowEditing={false} width={140} />
        <Column
          dataField={'CreatedOn'}
          allowEditing={false}
          dataType="datetime"
        />
        <Column
          dataField={'UpdatedOn'}
          caption={'Last Logon'}
          allowEditing={false}
          dataType="datetime"
        />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default Device;
